// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { IconWrapper } from "@insite/mobius/Icon";
import { productAvailabilityStyles } from "@synd/Overrides/Components/ProductAvailability";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

productAvailabilityStyles.container = {
    gap: 0,
    offsetCss: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px 32px;
    `,
};
productAvailabilityStyles.errorText = {
    weight: fontConfig.weight.bold,
    color: "danger",
    ...fontConfig.xSmallSingleLine,
};

productAvailabilityStyles.inventoryMessage = {
    css: css`
        background-color: transparent;
        display: flex;
        align-items: center;
        padding: 0;
        border-radius: 0;
        gap: 2px 6px;
        ${IconWrapper} {
            margin-right: 0px;
        }
        ${wrapInContainerStyles}
    `,
};
productAvailabilityStyles.messageText = {
    ...fontConfig.xSmallSingleLine,
    css: css`
        width: 100%;
        letter-spacing: 0;
        @media print {
            word-break: normal;
        }
    `,
};

productAvailabilityStyles.availabilityByWarehouseModal = {};
productAvailabilityStyles.messageGridItem = {
    width: 12,
};

productAvailabilityStyles.centeringWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
